import ReactGA from "react-ga4";

const TRACKING_ID = "G-XPD57V9MQ2"; 

export const initGA = () => {
    ReactGA.initialize(TRACKING_ID);
};

export const logPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
